/* 2026-10-13 · cart v2 (oma side cart), preview behind ?cartv2=1.
   1. "✓ Toegevoegd: <name>" after an add, from the drawer's own render.
   2. Estimated delivery above Checkout, same rules as the PDP (drippy-eta).
   3. Suggestion rows: "+ Toevoegen" opens the sizes in the cart, a size adds
      it and re-renders the drawer the way the theme's own add does. */
(function () {
  if (!document.documentElement.classList.contains('cart-v2')) return;
  var lastAdded = null;

  function eta(root) {
    [].slice.call((root || document).querySelectorAll('[data-cv2-eta]')).forEach(function (el) {
      try {
        var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()).split('-');
        var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12));
        var wk = function (x) { var g = x.getUTCDay(); return g === 0 || g === 6; };
        if (el.hasAttribute('data-kg')) {
          d.setUTCDate(d.getUTCDate() + 1);
          if (el.hasAttribute('data-bo')) {
            while (wk(d)) d.setUTCDate(d.getUTCDate() + 1); /* backorder: 5-10 working days, Mon to Fri */
          } else {
            if (d.getUTCDay() === 0) d.setUTCDate(d.getUTCDate() + 1);
            wk = function (x) { return x.getUTCDay() === 0; };
          }
        } else {
          while (wk(d)) d.setUTCDate(d.getUTCDate() + 1);
        }
        var add = function (n) { var x = new Date(d); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (!wk(x)) n--; } return x; };
        var loc = el.dataset.locale || 'en', mn = +el.dataset.min, mx = +el.dataset.max;
        var fs = new Intl.DateTimeFormat(loc, { month: 'short', day: 'numeric', timeZone: 'UTC' });
        var html;
        if ((el.dataset.country === 'NL' || el.dataset.country === 'BE') && !el.hasAttribute('data-kg')) {
          var due = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2] + 1, 12)), next = new Date(due), word;
          while (wk(due)) due.setUTCDate(due.getUTCDate() + 1);
          word = due.getTime() === next.getTime() ? new Intl.RelativeTimeFormat(loc, { numeric: 'auto' }).format(1, 'day') : new Intl.DateTimeFormat(loc, { weekday: 'long', timeZone: 'UTC' }).format(due);
          html = el.dataset.singleT.replace('%F', word);
        } else if (mn === mx) {
          html = el.dataset.singleT.replace('%F', fs.format(add(mx)));
        } else {
          html = el.dataset.rangeT.replace('%A', fs.format(add(mn))).replace('%B', fs.format(add(mx)));
        }
        var tgt = (el.parentNode && el.parentNode.querySelector('.cv2-ship__eta')) || el;
        if (tgt.innerHTML !== html) tgt.innerHTML = html;
        el.setAttribute('data-done', '');
      } catch (e) {}
    });
  }

  function added(drawer) {
    var box = drawer.querySelector('[data-cv2-added]');
    if (!box || !lastAdded) return;
    var line = drawer.querySelector('.cart-item[data-product-id="' + lastAdded + '"] .cart-item__name');
    if (!line) return;
    box.querySelector('[data-cv2-added-name]').textContent = line.textContent.trim();
    box.hidden = false;
  }

  function hook() {
    var CD = customElements.get('cart-drawer');
    if (!CD || CD.prototype.__cv2) return !!CD;
    var orig = CD.prototype.renderContents;
    CD.prototype.renderContents = function (state) {
      lastAdded = state && (state.id || (state.items && state.items[0] && state.items[0].id)) || null;
      orig.apply(this, arguments);
      eta(this); added(this);
    };
    CD.prototype.__cv2 = true;
    return true;
  }
  if (!hook()) customElements.whenDefined('cart-drawer').then(hook);

  // the drawer re-renders its inside on quantity changes; refill an empty date
  // (only when one is empty, so filling it in never retriggers itself)
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    var empty = document.querySelector('[data-cv2-eta]:not([data-done])');
    if (!empty) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; eta(document); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', function () { eta(document); });
  eta(document);

  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest && t.closest('[data-cv2-open]');
    if (open) {
      e.preventDefault();
      var rec = open.closest('[data-cv2-rec]'), sz = rec.querySelector('[data-cv2-sizes]');
      sz.hidden = !sz.hidden; open.setAttribute('aria-expanded', String(!sz.hidden));
      // the size she found with "Vind je maat" / "Vind je lengte" is marked and ready
      if (!sz.hidden && !sz.dataset.picked) {
        sz.dataset.picked = '1';
        var mine = null, type = rec.dataset.type;
        try { mine = localStorage.getItem('drippy:pick-' + type); } catch (err) {}
        if (mine) {
          var hit = [].slice.call(sz.querySelectorAll('[data-cv2-add]')).filter(function (b) {
            return !b.disabled && (type === 'ring' ? b.dataset.name === mine : parseFloat(b.dataset.cm) === parseFloat(mine));
          })[0];
          if (hit) {
            hit.classList.add('is-mine');
            var tag = document.createElement('small');
            tag.textContent = (rec.closest('.cv2-recs') || {}).dataset ? rec.closest('.cv2-recs').dataset.mine || '' : '';
            hit.appendChild(tag);
          }
        }
      }
      return;
    }
    var addBtn = t.closest && t.closest('[data-cv2-add]');
    if (!addBtn || addBtn.disabled) return;
    e.preventDefault();
    var row = addBtn.closest('[data-cv2-rec]'), drawer = document.querySelector('cart-drawer');
    if (row) row.classList.add('is-busy');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    /* 2026-10-15 · sets: adding a piece's set partner turns the pair into a
       set. The piece already in the bag gets a _bundle_id first, the partner
       is added with the same id, and the checkout applies the set price. */
    var setLine = row && row.getAttribute('data-set-line');
    var props = null, first = Promise.resolve();
    if (setLine) {
      var bid = 'set-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      props = { _bundle_id: bid, _bundle_name: row.getAttribute('data-set-handle') || '', _bundle_handle: row.getAttribute('data-set-handle') || '' };
      first = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var it = (c.items || []).filter(function (x) { return x.key === setLine; })[0];
        if (!it) return;
        var p2 = Object.assign({}, it.properties || {}, props);
        return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: setLine, quantity: it.quantity, properties: p2 }) });
      }).catch(function () {});
    }
    var addBody = { id: +addBtn.dataset.cv2Add, quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname };
    if (props) addBody.properties = props;
    var setCode = row && row.getAttribute('data-set-code');
    first.then(function () { return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(addBody)
    }); }).then(function (r) { return r.json(); }).then(function (res) {
      if (!props || !setCode || res.status) return res;
      /* the set price is the set's discount code: apply it, keep codes already there */
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); }).then(function (c) {
        var list = (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        if (list.indexOf(setCode) === -1) list.push(setCode);
        return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: list.join(','), sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) }).then(function (x) { return x.json(); });
      }).catch(function () { return res; });
    }).then(function (res) {
      if (res && res.sections && drawer && drawer.renderContents) drawer.renderContents(res);
      else if (row) row.classList.remove('is-busy');
    }).catch(function () { if (row) row.classList.remove('is-busy'); });
  }, true);   // capture: the theme's drawer stops clicks from bubbling up
})();
